import React from 'react';
import { ModalMode } from '../ConnectedTeams';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import SecondaryButton from '../../../../../Elements/ids/Buttons/SecondaryButton';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ids/react-button';
import PrimaryButton from '../../../../../Elements/ids/Buttons/PrimaryButton';

const ConnectedTeamsButtons = ({
  closeView,
  modalMode,
  removeTeam,
  connectTeam,
  setModalMode,
  connectTeamDisabled,
  setSelectedTeam,
}) => {
  return (
    <>
      {modalMode === ModalMode.view || modalMode === ModalMode.notFound ? (
        <>
          <SecondaryButton text={formatMessage(Messages.common_close)} onClickEvent={closeView} />
          <PrimaryButton
            text={formatMessage(Messages.employerPage_connectedTeams_newTeam)}
            onClickEvent={() => {
              setModalMode(ModalMode.connectTeam);
            }}
          />
        </>
      ) : modalMode === ModalMode.removeTeam ? (
        <>
          <SecondaryButton
            text={formatMessage(Messages.common_cancel)}
            onClickEvent={() => {
              setModalMode(ModalMode.view);
              setSelectedTeam(null);
            }}
          />
          <Button size={ButtonSize.MEDIUM} type={ButtonType.FILLED} variant={ButtonVariant.DANGER} onClick={removeTeam}>
            {formatMessage(Messages.employerPage_connectedTeams_accept)}
          </Button>
        </>
      ) : modalMode === ModalMode.connectTeam ? (
        <>
          <SecondaryButton
            text={formatMessage(Messages.common_cancel)}
            onClickEvent={() => {
              setModalMode(ModalMode.view);
              setSelectedTeam(null);
            }}
          />
          <PrimaryButton
            text={formatMessage(Messages.employerPage_connectedTeams_searchTeamButton)}
            disabled={connectTeamDisabled}
            onClickEvent={connectTeam}
          />
        </>
      ) : modalMode === ModalMode.error ? (
        <>
          <PrimaryButton text={formatMessage(Messages.common_ok)} onClickEvent={() => setModalMode(ModalMode.view)} />
        </>
      ) : null}
    </>
  );
};

export default ConnectedTeamsButtons;
